export default __webpack_public_path__ + "static/product-feature-editor-d4986af8f8bd8e6d3125c27fa5e6b2dd.svg";